const STATUS_STYLES = {
  info: {
    tone: "border-blue-100 bg-blue-50 text-grey-300",
    dot: "bg-blue-100 animate-pulse",
  },
  success: {
    tone: "border-green-200 bg-green-50 text-green-800",
    dot: "bg-green-600",
  },
  error: {
    tone: "border-red-200 bg-red-50 text-red-700",
    dot: "bg-red-500",
  },
};

export default function CliAuthStatusCard({ tone = "info", title, message }: { tone?: keyof typeof STATUS_STYLES; title: string; message: string }) {
  const style = STATUS_STYLES[tone] || STATUS_STYLES.info;

  return (
    <div className={`rounded-md border px-4 py-3 ${style.tone}`}>
      <div className="flex items-center gap-2">
        <span
          className={`inline-flex h-2 w-2 rounded-full ${style.dot}`}
          aria-hidden="true"
        />
        <span className="text-[0.95rem] font-semibold">{title}</span>
      </div>
      <p className="mt-1.5 text-sm">{message}</p>
    </div>
  );
}
